import { Controller } from '@hotwired/stimulus'

interface MercureEventData {
  event_type?: string
  associated_person_id?: string
  grantee_profile_id?: string
}

/**
 * Listens for the global `MercureEvent` (dispatched by the single app-wide
 * EventSource in app.js). When an `access_grant_approved` event arrives for the
 * Associated Person currently being viewed, the page is reloaded so the freshly
 * granted Tier 3 view is server-rendered.
 *
 * The grant event is published to the grantee's own profile notification topic,
 * so a different grantee's event never reaches this browser. We additionally guard
 * on `grantee_profile_id` when the payload carries it.
 */
export default class MercureGrantController extends Controller {
  static values = {
    apId: String,
    profileId: String
  }

  declare readonly apIdValue: string
  declare readonly profileIdValue: string

  initialize (): void {
    this.handleMercureEvent = this.handleMercureEvent.bind(this)
  }

  connect (): void {
    document.addEventListener('MercureEvent', this.handleMercureEvent)
  }

  disconnect (): void {
    document.removeEventListener('MercureEvent', this.handleMercureEvent)
  }

  handleMercureEvent (event: Event): void {
    const data = (event as CustomEvent).detail?.data as MercureEventData | undefined

    if (data === undefined || data === null) {
      return
    }

    if (data.event_type !== 'access_grant_approved') {
      return
    }

    if (data.associated_person_id !== this.apIdValue) {
      return
    }

    if (
      typeof data.grantee_profile_id === 'string' &&
      this.profileIdValue !== '' &&
      data.grantee_profile_id !== this.profileIdValue
    ) {
      return
    }

    window.location.reload()
  }
}
